module.exports = __webpack_public_path__ + "assets/3e260914f8a128e004406ce3406db76e.png";